










































import { Vue, Component } from 'vue-property-decorator';
import { Cell, CellGroup, Field, Button, Toast, Popup } from 'vant';
import Uploader from '@/components/Uploader.vue';
import SlideVerify from '@/components/SlideVerify.vue';
import { save } from '@/api/api';
import { isWeiXin } from '@/common/ts/common';
import * as config from './config';
Vue.use(Cell)
  .use(Field)
  .use(CellGroup)
  .use(Button)
  .use(Popup);
@Component({
  components: {
    Uploader,
    SlideVerify,
  },
})
export default class Upload extends Vue {
  option = config.OPTHINES;
  nameValue = '';
  message = '';
  cover = '';
  phone = '';
  chinaid = '';
  SlideShow = false;
  submit() {
    if (!window.udid && !isWeiXin()) {
      return Toast('请在上游客户端或微信参与');
    } else {
      this.StartSubmit();
    }
  }
  StartSubmit() {
    (this.$refs.uploaderImage as Uploader).uploadToOss().then((res) => {
      console.log('img urls result:', '|' + (res as any).join('|'));
      this.cover = '|' + (res as any).join('|');
      if (
        !this.nameValue ||
        !this.message ||
        !this.cover ||
        !this.phone ||
        !this.chinaid
      ) {
        Toast.fail('填写不完整,或者信息有错误');
        return;
      } else {
        this.SlideShow = true;
      }
    });
  }
  fSlideData() {
    const data = {
      title: this.nameValue,
      introduction: this.message,
      cover: this.cover,
      phone: this.phone,
      chinaid: this.chinaid,
    };
    save(this.option.voteName, data).then((res: any) => {
      if (res.code === 200) {
        this.SlideShow = false;
        Toast.success('提交成功');
        this.$router.push('./One');
      } else {
        this.SlideShow = false;
        Toast('上传失败！请重新填写');
        setTimeout(() => {
          window.location.reload();
        }, 500);
      }
    });
  }

  onBlur() {
    const u = navigator.userAgent;
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isiOS) {
      window.scrollTo(0, 0);
    }
  }
}
